import { Component, ElementRef, ChangeDetectorRef } from '@angular/core';
import { MenuService } from '../menu.service';
import { Observable, Subject } from 'rxjs';
@Component({
    selector: '[menu-item]',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    exportAs: 'menuItem',
    host: {
        'class': 'menu-item'
    },
    standalone: false
})
export class MenuItemComponent {
    opensChildMenu: boolean = false;
    hoverChanged: Observable<void> = new Subject<void>();

    constructor(
        public _menuService: MenuService,
        public elementRef: ElementRef,
        public changeDetectorRef: ChangeDetectorRef
    ) { }

    ngOnDestroy() {
        (this.hoverChanged as Subject<void>).complete();
    }

    onClick(e: MouseEvent) {
        if (!this.opensChildMenu)
            this._menuService.menuItemClicked.emit(this);
    }

    open() {
        this._menuService.onItemEntered.emit(this);
        (this.hoverChanged as Subject<void>).next();
    }
}
